import { IContactCompany } from 'models/contact_companies'
import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

type CustomFields = 'type' | 'opportunity_type'

export const COMPANIES_COLUMNS = {
  name: {
    header: 'Company',
    group: 'Target Attributes',
  },
  created: {
    header: 'Date Created',
    group: 'Target Attributes',
  },
  google_place_url: {
    header: 'Place URL',
    group: 'Target Attributes',
    tooltipName: 'opps_google_place_url',
  },
  city: {
    header: 'City',
    group: 'Target Attributes',
  },
  state: {
    header: 'State',
    group: 'Target Attributes',
  },
  country: {
    header: 'Country',
    group: 'Target Attributes',
  },
  domain: {
    header: 'Domain',
    group: 'Target Attributes',
  },
  address: {
    header: 'Address',
    group: 'Target Attributes',
  },
  zipcode: {
    header: 'ZIP Code',
    group: 'Target Attributes',
  },
  category: {
    header: 'Category',
    group: 'Target Attributes',
  },
  type: {
    header: 'Type',
    group: 'Target Attributes',
  },
  opportunity_type: {
    header: 'Opportunity Type',
    group: 'Target Attributes',
  },
  phone_number: {
    header: 'Phone Number',
    group: 'Target Attributes',
  },
  extension: {
    header: 'Extension',
    group: 'Target Attributes',
  },
} satisfies Partial<
  Record<CustomFields | keyof IContactCompany, DataTypeColumn>
>
